module.exports = __webpack_public_path__ + "static/img/newCommer.c4c79a43.png";